import React from 'react';
import InfoBox from './InfoBox';
import { translate } from '../Services/translation';
import Icon from './Icon';
import clsx from 'clsx';
import { InfoBoxPlacements } from '../constants';
import { useIsBendixTheme } from '../Hooks/ChannelHooks';

const StockStatus = ({
  inStock,
  description,
  showInfoBox,
  showInfoBoxMessage,
  stockMessage,
  placement = InfoBoxPlacements.Top,
  extendedStockStatus = undefined,
  packageSize = 0,
  minimal = false,
  isOnRequestPortion = false,
}) => {
  // When a row represents the on-request portion of a stock-overflow split (Bendix checkout),
  // override the usual icon with a question mark and surface the same kind of clickable InfoBox
  // tooltip used for "On Request" items elsewhere on the site — but with a portion-specific
  // explanation.

  const isBendix = useIsBendixTheme();
  if (isOnRequestPortion) {
    return (
      <div className="stock-status">
        <InfoBox
          label={
            <Icon
              name="Question-Rounded"
              className="stock-status__icon on-request"
              size={isBendix ? 18 : 24}
            />
          }
          id="stock-status-on-request-portion"
          placement={placement}
        >
          {translate('product.stockstatus.info.On-RequestPortion')}
        </InfoBox>
      </div>
    );
  }

  if (extendedStockStatus) {
    return extendedStockStatus.map((extendedStock) => {
      const {
        description: extendedDescription,
        inStock: extendedInStock,
        inStockQuantity,
      } = extendedStock;

      const isOnRequest =
        extendedInStock && inStockQuantity > 0 && packageSize > inStockQuantity;

      return (
        <div key={inStockQuantity} className="stock-status">
          <Icon
            name={
              isOnRequest
                ? 'Caution-Rounded-Filled'
                : extendedInStock
                ? 'Check-Rounded-Filled'
                : 'Caution-Rounded-Filled'
            }
            className={clsx(
              'stock-status__icon',
              isOnRequest
                ? 'on-request'
                : extendedInStock
                ? 'in-stock'
                : 'out-of-stock'
            )}
            size={18}
          />
          {!minimal &&
            (extendedInStock ? (
              <div className="stock-status__description">
                {extendedDescription}
              </div>
            ) : (
              <InfoBox
                label={extendedDescription}
                id="stock-status-box"
                placement={placement}
              >
                {showInfoBoxMessage}
              </InfoBox>
            ))}
        </div>
      );
    });
  }

  return (
    <div className="stock-status">
      <Icon
        name={inStock ? 'Check-Rounded-Filled' : 'Caution-Rounded-Filled'}
        className={clsx(
          'stock-status__icon',
          inStock ? 'in-stock' : 'on-request'
        )}
        size={24}
      />
      {description && (
        <div className="stock-status__description">{description}</div>
      )}
      {showInfoBox ? (
        <InfoBox
          label={stockMessage}
          id="stock-status-box"
          placement={placement}
        >
          {showInfoBoxMessage}
        </InfoBox>
      ) : (
        <div className="stock-status__message">{stockMessage}</div>
      )}
    </div>
  );
};

export default StockStatus;
